import { render, staticRenderFns } from "./BenchmarkPanel.vue?vue&type=template&id=e3b62fe8&scoped=true"
import script from "./BenchmarkPanel.vue?vue&type=script&lang=ts"
export * from "./BenchmarkPanel.vue?vue&type=script&lang=ts"
import style0 from "./BenchmarkPanel.vue?vue&type=style&index=0&id=e3b62fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b62fe8",
  null
  
)

export default component.exports